import {
  heartbeatStatusIconColumnDefinition,
} from '../columnDefinitions';

export default [
  heartbeatStatusIconColumnDefinition,
];
